import React from "react";
import BasicInfoFields from "../BasicInfo/BasicInfoFields";
import { NavigationalButtons } from "./CreateAudioWizard";
import Form from "../../../../Forms/Form";

const BasicInfoStep = ({ disabled, audioId}) => {
  return (
    <div>
      <Form>
        <BasicInfoFields disabled={disabled} audioId = {audioId}/>
        <NavigationalButtons
          onNextProps={{ type: "submit", text:  "Save and Continue" }}
        />
      </Form>
    </div>
  );
};

export default BasicInfoStep;
